/** @jsxImportSource ./simboluri-jsx */
// ȘABLONUL UNIC al antetului de pas (mock-ui/design/StrPasStrategie +
// StrPasSeism): breadcrumb cu CAPITOLUL pasului + vecinii lanțului +
// întrebarea din catalog_pasi + INDICATORUL DE VERDICTE — „N verificări,
// M picate" din tabloul de acoperire al Pasului 19, sau, la pașii care
// DECID în loc să VERIFICE, declarația explicită „fără verdicte proprii".
// Conținutul pașilor rămâne al fiecărei pagini; antetul e același pentru toți.

import { useT } from "../i18n";
import { StepState } from "./tipuri";
import { useCatalogPasi } from "./useCatalog";
import { CAPITOLE } from "./capitole";
import { STEPS, hashSectiune, pasScurt, titluPas } from "./legaturi";
import { nr } from "./elemente";

export default function PasAntet({
  id,
  solutie,
  pasKey,
  steps,
}: {
  id: string;
  solutie?: string | null;
  pasKey: string;
  steps: Record<string, StepState>;
}) {
  const catalog = useCatalogPasi();

  const t = useT();
  const i = STEPS.findIndex((s) => s.key === pasKey);
  const pas = STEPS[i];
  const prev = i > 0 ? STEPS[i - 1] : null;
  const next = i >= 0 && i < STEPS.length - 1 ? STEPS[i + 1] : null;
  const cap = CAPITOLE.find((c) => c.pasi.includes(pasKey));
  const fisa = catalog?.pasi?.[pasKey];

  /* eslint-disable @typescript-eslint/no-explicit-any */
  // indicatorul de verdicte al pasului, din tabloul de acoperire al P17
  const r = steps["optimizare_structura"]?.result as any;
  const stare = r?.raport_solutie?.final ?? r?.stare_finala ?? null;
  const rand = (stare?.acoperire ?? []).find((a: { pas: string }) => a.pas === pasKey);
  const faraVerdicte = (stare?.pasi_fara_verdicte ?? []).find(
    (p: { pas: string }) => p.pas === pasKey
  );
  /* eslint-enable @typescript-eslint/no-explicit-any */

  if (!pas) return null;
  // linkul capitolului: 4 și 5 au paginile lor, restul intră pe primul pas
  const hrefCap = cap
    ? hashSectiune(
        id,
        cap.nr === 5 ? "elemente" : cap.nr === 4 ? "fundatie" : cap.pasi[0],
        solutie ?? null
      )
    : null;

  return (
    <div className="ob-pas-antet" style={{ flexDirection: "column", alignItems: "stretch", gap: 6 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        <a href={hashSectiune(id, "pipeline", solutie ?? null)}>{t("struct.antet.pipeline")}</a>
        {cap && hrefCap && (
          <>
            <span>/</span>
            <a href={hrefCap}>{t("struct.antet.capitol", { nr: cap.nr, titlu: t(cap.titlu) })}</a>
          </>
        )}
        <span>/</span>
        <span style={{ color: "var(--ink)", fontWeight: 500 }}>{titluPas(pas.key)}</span>
        <span className="ob-pas-nav">
          {prev && (
            <a href={hashSectiune(id, prev.key, solutie ?? null)} title={titluPas(prev.key)}>
              ← {pasScurt(prev.key)}
            </a>
          )}
          {next && (
            <a href={hashSectiune(id, next.key, solutie ?? null)} title={titluPas(next.key)}>
              {pasScurt(next.key)} →
            </a>
          )}
        </span>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
        {fisa?.intrebarea && (
          <span style={{ fontSize: 12, color: "var(--mut)" }}>„{fisa.intrebarea}"</span>
        )}
        <span style={{ flex: 1 }} />
        {rand && rand.nr_verificari > 0 ? (
          <>
            <span
              className={`ob-chip ${rand.nr_picate ? "ob-c-bad" : "ob-c-ok"}`}
              title={t("struct.antet.verdicte_titlu")}
            >
              {rand.nr_picate
                ? t("struct.antet.picate", { picate: nr(rand.nr_picate), total: nr(rand.nr_verificari) })
                : t("struct.antet.toate_trec", { n: nr(rand.nr_verificari) })}
            </span>
            {rand.nr_la_limita ? (
              <span className="ob-chip ob-c-amb">{t("struct.antet.la_limita", { n: nr(rand.nr_la_limita) })}</span>
            ) : null}
          </>
        ) : faraVerdicte ? (
          <span
            className="ob-chip ob-c-mut"
            title={faraVerdicte.de_ce}
          >
            {t("struct.antet.fara_verdicte")}
          </span>
        ) : null}
      </div>
    </div>
  );
}
